import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Dtn209Service {

  constructor() { }
}
